export enum FamilyRightsEnum {
  navigation = 'Accès menu navigation',
  composant = 'Composant',
  patrimoine = 'C&E Patrimoine',
  campagne = 'Campagne',
  administration = 'Administration',
  api = 'Accès Api'
}
